<template>
  <el-select
    filterable
    remote
    value-key="id"
    v-model="ticket"
    :remote-method="searchTicket"
    placeholder="输入工单标题或编号搜索"
    @change="onChange"
    clearable
    :style="css">
    <el-option v-for="item in ticketList"
      :key="item.orderId"
      :label="item.orderTitle + '(' + item.orderId + ')'"
      :value="item" />
  </el-select>
</template>

<script>
export default {
    name : 'TicketSearch',

    props : ['value', 'css'],

    data() {
        return {
            ticket : null,
            ticketList : []
        };
    },

    methods : {
        searchTicket( _query ) {
            var _this = this;
            sdk.TicketApi().list({
                filter : {
                    '$or' : [
                        { '$like' : { 'orderTitle' : '%' + _query + '%' } },
                        { '$like' : { 'orderId' : '%' + _query + '%' } }
                    ]
                },
                page : { pageSize : 10 }
            }).then(res => {
                _this.ticketList = res.list;
            });
        },

        onChange(e) {
            this.$emit('input', e.orderId);
            this.$emit("change", Object.assign({'_type' : 'ticket_form_vertical', '_id' : e.orderId}, e));
        }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/ticket/TicketSearch.vue